const LETTER = /\p{L}/u;
const ARABIC = /[؀-ۿݐ-ݿࢠ-ࣿﭐ-﷿ﹰ-﻿]/;
/** Zero-width non-joiner: keeps two Arabic initials as separate letters instead of a joined word. */
const ZWNJ = '‌';

/**
 * Initials for the avatar "initials" context (DGA criterion 31): the first letter of the first word and,
 * when there is more than one word, of the last word. Works for Arabic and Latin names; punctuation and
 * digits are skipped; returns '' when the name has no letters.
 */
export function getAvatarInitials(name: string | null | undefined): string {
  const words = (name ?? '').trim().split(/\s+/).filter(word => LETTER.test(word));
  if (!words.length) return '';

  const firstLetter = (word: string) => Array.from(word).find(char => LETTER.test(char)) ?? '';
  const letters = [firstLetter(words[0])];
  if (words.length > 1) letters.push(firstLetter(words[words.length - 1]));

  const joiner = letters.every(letter => ARABIC.test(letter)) ? ZWNJ : '';
  return letters.map(letter => letter.toLocaleUpperCase()).join(joiner);
}
